import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";

import { addAssessment } from "common/services/assessments.service";
import AssessmentForm, {
  assessmentValidationSchema,
  buildAssessmentFormData,
  getAssessmentInitialValues,
} from "./AssessmentForm";

const AddAssessment: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: getAssessmentInitialValues(),
    validationSchema: assessmentValidationSchema,
    onSubmit: async (values) => {
      const formData = buildAssessmentFormData(values);

      try {
        setLoading(true);
        await addAssessment(formData);
        fetchData();
        validation.resetForm();
        toggle();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="show-assessment-modal"
      size="xl"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add Assessment
      </ModalHeader>
      <AssessmentForm
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddAssessment;
